module.exports = __webpack_public_path__ + "img/lemon02_300px.3c0ef95a.jpg";